import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding, AfterContentInit } from '@angular/core';

export type PagingConfig = {
  start: number;
  count?: number;
  pageSize?: number;
}

export type NextHandler = (start: number, count: number) => void;
export type PrevHandler = (start: number, count: number) => void;

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagingComponent implements AfterContentInit {
  @HostBinding('class.pager') pager: boolean = true;
  private _start: number = 0;
  @Input('start') set start(v: number) {
    this._start = v;
    this.Refresh();
  }
  get start(): number {
    return this._start;
  }
  private _count: number = 0;
  @Input()
  set count(v: number) {
    this._count = v;
    this.Refresh();
  }
  get count(): number {
    return this._count;
  }

  private _size: number = 0;
  @Input()
  set size(v: number) {
    this._size = v;
    this.Refresh();
  }
  get size(): number {
    return this._size;
  }

  private _end:number = 0;
  @Input()
  public set end(v:number) {
    this._end = v;
    this.Refresh();
  }
  public get end():number {
    return this._end;
  }

  @Input() onNext: NextHandler = (start: number, count: number) => {

  }
  @Input() onPrev: NextHandler = (start: number, count: number) => {

  }
  private _label: string = '';

  @Input()
  set label(v: string) {
    this._label = v;
    this.Refresh();
  }
  get label(): string {
    return this._label;
  }


  public get hasData(): boolean {
    return !!this.count && this.count > 0;
  }

  private _ready: boolean = false;
  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterContentInit(): void {
    this._ready = true;
    this.cdr.detach();
    this.Refresh();
  }
  public Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

  HasPrev() {
    return this.start > 1;
  }
  HasNext() {
    return this.start + this.size < this.count;
  }
  Next() {
    if (!this.HasNext()) return;
    if (this.onNext) this.onNext(Math.min(this.start + this.size, this.count), this.size);
  }
  Prev() {
    if (!this.HasPrev()) return;
    if (this.onPrev) this.onPrev(Math.max(this.start - this.size, 1), this.count);
  }

}
